import Modal from "../Modal/Modal";
import { Container, MainButton } from "./AdditionalVolanteModalStyles";

function AdditionalServiceStatusModal(props) {
  const { toggleModal } = props;

  return (
    <Modal onOutsideClick={() => toggleModal()}>
      <Container width="37.5rem">
        <h1>Documento en revisión</h1>
        <p>
          Mientras este volante tenga un documento en revisión no podrá agregar
          servicios.
        </p>
        <MainButton onClick={() => toggleModal()}>Entendido</MainButton>
      </Container>
    </Modal>
  );
}

export default AdditionalServiceStatusModal;
